var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.32,3.65A1.24,1.24,0,0,0,4.55,3a9.13,9.13,0,1,0,9-.09,1.26,1.26,0,0,0-1.76.73h0a1.69,1.69,0,0,0,.76,1.95A6.33,6.33,0,1,1,5.13,15.76a6.27,6.27,0,0,1-2.21-3.7A6.38,6.38,0,0,1,3.59,7.8a6.47,6.47,0,0,1,2-2.19,1.68,1.68,0,0,0,.73-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.93,
    width: 2.76,
    height: 8.62,
    rx: 1.38
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.5ea37b0c68381d0674bf83bab1cca84d.svg";
export { ForwardRef as ReactComponent };